<template>
    <rkm-row>
        <rkm-col cols="12">
            <BoxAntropometria
                v-if="item.antropometria"
                :data="item.antropometria"
                hide-podometria
            />

            <BoxSinalVital
                v-if="item.sinalVital"
                :data="item.sinalVital"
            />

            <BoxGlicemiaCapilar
                v-if="item.glicemiaCapilar"
                :data="item.glicemiaCapilar"
            />

            <BoxProcedimento :item="item" />

            <BoxIdentificacao :item="item" />

            <BoxInformacaoAdministrativa :item="item" />

            <rkm-area title="Tempo Atendimento">
                <rkm-row>
                    <rkm-col cols="12">
                        <Item
                            :get-value="() => item.tempoAtendimento"
                            label="Tempo no atendimento"
                        />

                        <Item
                            :get-value="() => item.tempoAtendimentoUnidade"
                            label="Tempo na unidade"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>
    </rkm-row>
</template>

<script>
// Components.
import BoxAntropometria from '@/components/ambulatorio/atendimento/components/historico/components/antropometria/Index'
import BoxGlicemiaCapilar from '@/components/ambulatorio/atendimento/components/historico/components/glicemia-capilar/Index'
import BoxIdentificacao from '@/components/ambulatorio/atendimento/components/historico/components/acolhimento-identificacao/Index'
import BoxInformacaoAdministrativa from '@/components/ambulatorio/atendimento/components/historico/components/pre-atendimento/components/informacao-administrativa/Index'
import BoxProcedimento from './components/procedimento/Index'
import BoxSinalVital from '@/components/ambulatorio/atendimento/components/historico/components/sinal-vital/Index'
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {
        BoxAntropometria,
        BoxGlicemiaCapilar,
        BoxIdentificacao,
        BoxInformacaoAdministrativa,
        BoxProcedimento,
        BoxSinalVital,
        Item,
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>
